export default __webpack_public_path__ + "static/media/shenkar-thumb300.d25fc50b.png";